import React, { SVGProps } from "react";

export default function SupStar(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.4603 5.44004L10 3.69353L10.5397 5.44005C11.1224 7.32558 12.8656 8.61146 14.8391 8.61146H16.5219L14.9694 9.79741C13.4708 10.9423 12.845 12.9001 13.4018 14.7019L14.0047 16.653L12.7318 15.6806C11.119 14.4485 8.88103 14.4485 7.26822 15.6806L5.99529 16.653L6.59821 14.7019C7.155 12.9001 6.52921 10.9423 5.03059 9.79742L3.47815 8.61146H5.16089C7.1344 8.61146 8.87763 7.32558 9.4603 5.44004Z"
        stroke="currentColor"
      />
    </svg>
  );
}
